import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  ['Article']: {
    id: 'magazine.article',
    defaultMessage: 'Article',
  },
  ['Guest Article']: {
    id: 'magazine.guest-article',
    defaultMessage: 'Guest Article',
  },
  ['IDAGIO Meets']: {
    id: 'magazine.idagio-meets',
    defaultMessage: 'IDAGIO Meets',
  },
});

const ArticleSubheader = ({ category }) => {
  return <FormattedMessage {...messages[category]} />;
};

ArticleSubheader.propTypes = {
  category: PropTypes.string.isRequired,
};

export default ArticleSubheader;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleSubheader.js